import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { CatalogViewerNavControls } from "@app/super/catalog-viewer-nav-controls";
import { MetadataDownloadService } from "@services/metadata-download.service";
import { HasMarkedTextDirective } from "../../directives/has-marked-text.directive";

@Component({
	selector: "app-htmlviewer",
	templateUrl: "./htmlviewer.component.html",
	styleUrls: ["./htmlviewer.component.scss"],
	encapsulation: ViewEncapsulation.ShadowDom,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [HasMarkedTextDirective]
})
export class HtmlviewerComponent extends CatalogViewerNavControls implements OnInit, OnDestroy {
	constructor(
		protected metadataDownloadService: MetadataDownloadService,
		protected elRef: ElementRef
	) {
		super(
			metadataDownloadService
		);
	}
	ngOnDestroy(): void {
		this.deleteCanonical();
	}

	ngOnInit() {
		const loadedSeoContent = document.getElementById('__seo_html_prerender');
		const articleTag: Element = this.elRef.nativeElement.shadowRoot.querySelector('#htmlViewer');
		const prerenderArticleTag = loadedSeoContent?.querySelector('#__seo_prerender_content');

		if (prerenderArticleTag?.hasChildNodes()) {
			articleTag.append(...Array.from(prerenderArticleTag.childNodes));
			requestAnimationFrame(() => this.removePreloadSeoContent());
		} else {
			if (this.attachment) {
				articleTag.innerHTML = this.attachment?.text ?? '';
			}
			this.removePreloadSeoContent();
		}
		this.initCanonical();
	}

	private removePreloadSeoContent() {
		const preloads = document.querySelectorAll("[data-seo-preload]");
		preloads.forEach(preload => {
			preload?.remove();
		});
	}
}
